(function () {
  'use strict';

  // S650 价格跳变 · 阶段1（决策 #72）：TTCPriceCoordinator 单价格渲染器。
  // 唯一职责：在 S650 定制母体 / 4P 定制母体 + window.__TTC_PRICE_FIX__===true 时，
  // 读 live data-* 事实源（data-price-cents / data-ttc-addon-retail-cents /
  // data-ttc-full-retail-cents / data-optionize-total-cents 可选慢路径缓冲）派生最终价，
  // 一次同步调用写完该价格根内所有可见价格（D2C 主价 / dealer 净价 + Retail 小字 +
  // qty>1 Total）。调度：所有写方只调 markDirty() → 120ms trailing + rAF + 同值守卫 →
  // 一次净更新；中间态保持上一稳定值 + aria-busy，绝不落中间金额。
  // 红线：只读 data-*，绝不写 data-ttc-addon-retail-cents / data-ttc-full-retail-cents /
  // data-ttc-addon-writer；不触碰 variant 同步链；默认 OFF 时全函数 no-op（fail-open）。
  // B（2026-09-06 老板拍板）：4P 复刻 S650 路线 → gate/root 支持双 handle 表。

  var TARGET_HANDLES = [
    'mustang-s650-2024-carbon-fiber-interior-trim-customization',
    'mustang-2015-2023-carbon-fiber-interior-trim-kit-4-piece-set-customization'
  ];
  var SETTLE_MS = 120;

  var state = {
    active: false,
    dirty: false,
    timer: null,
    raf: null,
    fallbackTimer: null,
    roots: [],
    observer: null
  };

  function gate() {
    if (typeof document === 'undefined' || typeof window === 'undefined') return false;
    if (window.__TTC_PRICE_FIX__ !== true) return false;
    for (var i = 0; i < TARGET_HANDLES.length; i++) {
      if (document.querySelector('section[data-product-handle="' + TARGET_HANDLES[i] + '"]')) return true;
    }
    return false;
  }

  function intAttr(el, name) {
    if (!el || !el.getAttribute) return null;
    var raw = el.getAttribute(name);
    if (raw === null || raw === undefined || raw === '') return null;
    var n = Number(raw);
    if (!Number.isFinite(n) || n < 0) return null;
    return Math.round(n);
  }

  function setAttrIfChanged(el, name, value) {
    if (!el || !el.setAttribute) return;
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function setTextIfChanged(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function setHiddenIfNeeded(el, hidden) {
    if (!el) return;
    if (hidden) {
      if (el.setAttribute) el.setAttribute('hidden', '');
      if (el.classList && !el.classList.contains('hide')) el.classList.add('hide');
    } else {
      if (el.hasAttribute && el.hasAttribute('hidden')) el.removeAttribute('hidden');
      if (el.classList && el.classList.contains('hide')) el.classList.remove('hide');
    }
  }

  function setBusy(container, busy) {
    var live = container && container.closest ? container.closest('[id^="price-"]') : null;
    var target = live || container;
    if (target) setAttrIfChanged(target, 'aria-busy', busy ? 'true' : 'false');
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    var amount = (cents / 100).toFixed(precision);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length === 1 ? parts[0] : parts[0] + decimal + parts[1];
  }

  function formatMoney(cents, format) {
    var value = Number(cents);
    if (!Number.isFinite(value)) return '';
    if (typeof window !== 'undefined' && window.TTCDealerPricing && typeof window.TTCDealerPricing.formatMoney === 'function') {
      return window.TTCDealerPricing.formatMoney(value, format);
    }
    var template = format || '${{ amount }}';
    var token = template.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!token) return formatWithDelimiters(value, 2, ',', '.');
    var amount;
    switch (token[1]) {
      case 'amount_no_decimals':
        amount = formatWithDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        amount = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        amount = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        amount = formatWithDelimiters(value, 2, "'", '.');
        break;
      default:
        amount = formatWithDelimiters(value, 2, ',', '.');
    }
    return template.replace(token[0], function () { return amount; });
  }

  function effectiveFinalPercent(value) {
    var percent = Number(value);
    if (!Number.isFinite(percent) || percent <= 0 || percent >= 100) return 20;
    return percent;
  }

  function applyFinalDiscount(fullRetailCents, finalPercent) {
    var cents = Number(fullRetailCents);
    if (!Number.isFinite(cents) || cents < 0) return cents;
    var f = effectiveFinalPercent(finalPercent);
    return Math.round(cents * (100 - f) / 100);
  }

  // 全零售（税态无关）派生：容器 data-ttc-full-retail-cents（4C 守卫产物）优先；
  // 缺失/非法回退 base×1.25 + Σaddon；仍缺时尝试 Optionize 慢路径缓冲 ×1.25。
  function readFullRetailCents(container) {
    var direct = container && container.getAttribute ? intAttr(container, 'data-ttc-full-retail-cents') : null;
    if (direct !== null && direct > 0) return direct;
    var source = container && container.querySelector ? container.querySelector('[data-ttc-price-source]') : null;
    var base = intAttr(source, 'data-price-cents');
    if (base !== null && base > 0) {
      var addon = intAttr(source, 'data-ttc-addon-retail-cents') || 0;
      return Math.round(base * 125 / 100) + addon;
    }
    var optTotal = intAttr(source, 'data-optionize-total-cents') || intAttr(source, 'data-ttc-optionize-total-cents');
    if (optTotal !== null && optTotal > 0) return Math.round(optTotal * 125 / 100);
    return null;
  }

  function readQty(container) {
    var root = container && container.closest
      ? (container.closest('[data-product-handle]') || container.closest('.shopify-section') || container.closest('.product__price-container'))
      : null;
    var input = root && root.querySelector ? root.querySelector('input[name="quantity"]') : null;
    if (!input && typeof document !== 'undefined') input = document.querySelector('input[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : NaN;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function shouldShowCompareAt(compareAtCents, totalCents) {
    return compareAtCents !== null && compareAtCents !== undefined && compareAtCents > totalCents;
  }

  function shouldShowRetail(fullRetailCents, netCents) {
    return fullRetailCents !== null && fullRetailCents !== undefined && fullRetailCents > netCents;
  }

  // D2C 可见主价。compare-at 仅在 > 单价时显示；qty>1 走同一个写者（Total 前缀）。
  function renderD2C(container) {
    var source = container && container.querySelector ? container.querySelector('[data-ttc-price-source]') : null;
    if (!source) return;
    var base = intAttr(source, 'data-price-cents');
    if (base === null) { setBusy(container, true); return; }
    var addon = intAttr(source, 'data-ttc-addon-retail-cents');
    if (addon === null) addon = 0;
    // 可选慢路径 buffer：D3 瞬态 addon 属性缺席时，若 Optionize 总价可用且 >= 基价则仲裁。
    var optTotal = intAttr(source, 'data-optionize-total-cents') || intAttr(source, 'data-ttc-optionize-total-cents');
    if (addon === 0 && optTotal !== null && optTotal >= base) addon = optTotal - base;
    var unitTotal = base + addon;
    var qty = Math.max(1, readQty(container));
    var prefix = qty > 1 ? 'Total: ' : '';
    var totalText = formatMoney(unitTotal * qty);
    var compareAt = intAttr(source, 'data-compare-at-cents');
    var showCompare = shouldShowCompareAt(compareAt, unitTotal);
    var priceRoot = container.querySelector('.price') || container;
    var regular = priceRoot.querySelector('.price__regular');
    var sale = priceRoot.querySelector('.price__sale');
    if (showCompare) {
      if (!regular && typeof document !== 'undefined' && typeof document.createElement === 'function') {
        regular = document.createElement('div');
        regular.className = 'price__regular body3';
        if (typeof priceRoot.insertBefore === 'function') priceRoot.insertBefore(regular, source);
      }
      if (regular) setTextIfChanged(regular, formatMoney(compareAt * qty));
      if (sale) setTextIfChanged(sale, prefix + totalText);
      else setTextIfChanged(source, prefix + totalText);
    } else {
      if (regular && regular.textContent !== '') {
        setTextIfChanged(regular, '');
        setHiddenIfNeeded(regular, true);
      }
      setTextIfChanged(source, prefix + totalText);
    }
    setBusy(container, false);
  }

  // Dealer：净价大价 + Retail 小字在同一同步块原子写（前后无 await/microtask）。
  // Retail 仅在全零售 > 净价时显示；qty>1 的 Total 也由本写者输出。
  function renderDealer(container) {
    var source = container && container.querySelector ? container.querySelector('[data-ttc-price-source]') : null;
    var display = container.querySelector('.price__dealer-display');
    var retail = container.querySelector('[data-dealer-retail-value]');
    var cfg = container.querySelector('ttc-dealer-price');
    var full = readFullRetailCents(container);
    if (full === null || full <= 0) { setBusy(container, true); return; }
    var f = cfg && cfg.getAttribute ? cfg.getAttribute('data-final-percent') : '20';
    var fmt = cfg && cfg.getAttribute ? cfg.getAttribute('data-money-format') : undefined;
    var unitNet = applyFinalDiscount(full, f);
    var qty = Math.max(1, readQty(container));
    var prefix = qty > 1 ? 'Total: ' : '';
    var netText = prefix + formatMoney(unitNet * qty, fmt);
    var retailVisible = shouldShowRetail(full, unitNet);
    if (display) setTextIfChanged(display, netText);
    if (retail) {
      if (retailVisible) {
        setTextIfChanged(retail, prefix + formatMoney(full * qty, fmt));
        setHiddenIfNeeded(retail, false);
      } else {
        setTextIfChanged(retail, '');
        setHiddenIfNeeded(retail, true);
      }
    }
    setBusy(container, false);
  }

  function renderContainer(container) {
    if (!container) return;
    var isDealer = container.classList
      ? container.classList.contains('price__container--dealer')
      : String(container.className || '').indexOf('price__container--dealer') !== -1;
    if (isDealer) renderDealer(container);
    else renderD2C(container);
  }

  function rootEls() {
    var out = [];
    if (typeof document === 'undefined') return out;
    var selector = TARGET_HANDLES.map(function (h) {
      return 'section[data-product-handle="' + h + '"]';
    }).join(',');
    var sections = document.querySelectorAll(selector);
    for (var i = 0; i < sections.length; i++) {
      var roots = sections[i].querySelectorAll('.product__price-container');
      if (roots && roots.length) {
        for (var j = 0; j < roots.length; j++) out.push(roots[j]);
      } else {
        var containers = sections[i].querySelectorAll('.price__container, .price__container--dealer');
        if (containers && containers.length) out.push(sections[i]);
      }
    }
    return out;
  }

  function renderAll() {
    if (!state.active) return;
    state.roots = rootEls();
    for (var i = 0; i < state.roots.length; i++) {
      var root = state.roots[i];
      var containers = root.querySelectorAll('.price__container, .price__container--dealer');
      for (var j = 0; containers && j < containers.length; j++) {
        renderContainer(containers[j]);
      }
    }
  }

  function ensureObserver() {
    if (state.observer || typeof MutationObserver === 'undefined' || typeof document === 'undefined') return;
    state.observer = new MutationObserver(function () {
      markDirty();
    });
    state.observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-price-cents', 'data-ttc-addon-retail-cents', 'data-ttc-full-retail-cents', 'data-compare-at-cents']
    });
  }

  function mount() {
    state.active = gate();
    if (!state.active) { state.roots = []; return false; }
    ensureObserver();
    // 只挂载+触发 dirty，不立即写可见文本：保证 section fetch/挂载后的中间态
    // 也走 120ms trailing + rAF，一次净更新（不先写基价再写加价）。
    return true;
  }

  function commitRaf() {
    if (state.fallbackTimer && typeof clearTimeout === 'function') {
      clearTimeout(state.fallbackTimer);
      state.fallbackTimer = null;
    }
    state.raf = null;
    if (!state.dirty) return;
    state.dirty = false;
    renderAll();
  }

  function markDirty() {
    if (!state.active) { state.dirty = true; return; }
    state.dirty = true;
    if (state.timer && typeof clearTimeout === 'function') clearTimeout(state.timer);
    state.timer = setTimeout(function () {
      state.timer = null;
      if (typeof requestAnimationFrame === 'function') {
        if (state.raf && typeof cancelAnimationFrame === 'function') cancelAnimationFrame(state.raf);
        state.raf = requestAnimationFrame(commitRaf);
        // 后台/被遮挡标签页 rAF 会被节流：加一个 16ms 兜底 commit，
        // 保证「收敛 ≤300ms」在自动化与低可见度环境同样成立。
        if (state.fallbackTimer && typeof clearTimeout === 'function') clearTimeout(state.fallbackTimer);
        state.fallbackTimer = setTimeout(function () {
          state.fallbackTimer = null;
          if (state.raf && typeof cancelAnimationFrame === 'function') cancelAnimationFrame(state.raf);
          state.raf = null;
          commitRaf();
        }, 16);
      } else {
        commitRaf();
      }
    }, SETTLE_MS);
  }

  function activate() {
    state.active = gate();
    if (state.active) {
      ensureObserver();
      markDirty();
      return true;
    }
    return false;
  }

  function isActive() { return state.active; }

  function isSettled(source) {
    return intAttr(source, 'data-price-cents') !== null;
  }

  window.TTCPriceRenderer = {
    markDirty: markDirty,
    mount: mount,
    activate: activate,
    render: renderAll,
    isActive: isActive,
    isSettled: isSettled,
    helpers: {
      intAttr: intAttr,
      formatMoney: formatMoney,
      applyFinalDiscount: applyFinalDiscount,
      effectiveFinalPercent: effectiveFinalPercent,
      readFullRetailCents: readFullRetailCents,
      shouldShowCompareAt: shouldShowCompareAt,
      shouldShowRetail: shouldShowRetail
    },
    __test: {
      state: state,
      setActive: function (v) { state.active = !!v; },
      renderContainer: renderContainer,
      renderAll: renderAll,
      markDirty: markDirty,
      flush: function () {
        if (state.timer && typeof clearTimeout === 'function') { clearTimeout(state.timer); state.timer = null; }
        if (state.fallbackTimer && typeof clearTimeout === 'function') { clearTimeout(state.fallbackTimer); state.fallbackTimer = null; }
        if (state.raf && typeof cancelAnimationFrame === 'function') { cancelAnimationFrame(state.raf); state.raf = null; }
        state.dirty = false;
        renderAll();
      }
    }
  };

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { mount(); markDirty(); });
    } else {
      mount();
      markDirty();
    }
  }
})();
